import React from 'react';
import { TextFieldProps } from '@mui/material';
import TextField from './TextField';

export const Input = (props: TextFieldProps): JSX.Element => {
  return <TextField variant="filled" {...props} />;
};

export default Input;
